import type { Permission } from "~/types/auth.type";

export const managerPermissions: Permission = {
  building: {
    read: true,
    lastPresenceDetected: {
      read: true,
    },
  },
  multisensor: {
    error: true,
    warning: true,
    read: true,
    mac: { update: true },
    sensors: {
      humidity: {
        read: true,
      },
      light: {
        read: true,
      },
      indoorAirQuality: {
        read: true,
      },
    },
  },
  valve: {
    error: true,
    warning: true,
    read: true,
    mac: { update: true },
    stateData: {
      temperatureCorrectionCoef: {
        read: true,
      },
      autoConf: { read: true },
      autoPreConf: {
        read: true,
      },
      anticipation: {
        read: true,
      },
      openWin: {
        read: true,
      },
    },
    commands: {
      temperatureCorrectionCoef: {
        read: true,
        update: true,
      },
    },
    sensors: {
      humidity: {
        read: true,
      },
      light: {
        read: true,
      },
      indoorAirQuality: {
        read: true,
      },
    },
    closing: {
      read: true,
    },
    correctedTemp: {
      read: true,
    },
  },
  gateway: {
    error: true,
    warning: true,
    read: true,
    mac: { update: true },
  },
  floor: {
    read: true,
  },
  room: {
    error: true,
    warning: true,
    read: true,
    name: {
      update: true,
    },
    type: {
      update: true,
    },
    comfortTemperature: {
      update: true,
    },
    nightTemperature: {
      update: true,
    },
    frostFree: {
      update: true,
    },
    isSwitchEnabled: {
      update: true,
    },
    isAutoPrecomf: {
      update: true,
    },
    isPreComfRoom: {
      update: true,
    },
    covSensorParam: {
      status: { update: true, read: true },
      periods: { update: true },
    },
    soundSensorParam: {
      status: { update: true, read: true },
    },
  },
  planning: {
    create: true,
    update: true,
  },
  alarm: {
    read: true,
    update: true,
  },
  history: {
    valve: { histoValve: { read: true } },
  },
  page: {
    maintenance: true,
    alarms: true,
    ressource: true,
    settings: true,
  },
};
